// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3Ar4y","loadingShrink":"PageLoading_loadingShrink__2EqR4"};